export default __webpack_public_path__ + "static/media/empty.c6ed4938.png";